import React from 'react';
import { Container } from 'react-bootstrap';
import check from '../../assets/images/check.png';

const EmailVerifySuccess = () => {
  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-4 text-center mt-5'>

        {/* Success Condition */}
        <img src={check} className='' alt='check' width={60} />
        <h5 className='mt-3 mb-3'>Email verified.</h5>
        <p className='mb-0'>Your email address was successfully verified.</p>
        <p>You can continue using the application.</p>
      </Container>
    </div >
  );
};

export default EmailVerifySuccess;